import React from 'react';
import { useLocale, REGIONS } from '@/contexts/LocaleContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

const RegionSelector = ({ variant = 'default', showLabel = true }) => {
  const { region, currentRegion, changeRegion } = useLocale();

  const buttonClass = variant === 'minimal' 
    ? 'h-9 px-2 gap-1 text-sm'
    : 'h-10 px-3 gap-2';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className={buttonClass}
          data-testid="region-selector"
        >
          <span className="text-base">{currentRegion.flag}</span>
          {showLabel && (
            <span className="hidden sm:inline">{currentRegion.code}</span>
          )}
          <Globe className="w-4 h-4 text-slate-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {Object.values(REGIONS).map((reg) => (
          <DropdownMenuItem
            key={reg.code}
            onClick={() => changeRegion(reg.code)}
            className={`cursor-pointer ${region === reg.code ? 'bg-slate-100' : ''}`}
            data-testid={`region-option-${reg.code}`}
          >
            <span className="text-lg mr-3">{reg.flag}</span>
            <div className="flex flex-col">
              <span className="font-medium">{reg.name}</span>
              <span className="text-xs text-slate-500">
                {reg.language === 'es' ? 'Español' : 'English'} • {reg.currency}
              </span>
            </div>
            {region === reg.code && (
              <span className="ml-auto text-emerald-600">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RegionSelector;
